import React, { useState, useCallback } from 'react';
import Modal from 'simple-react-modal';

import { SEND_AFFILIATE_CONTACT_FORM } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';


function AffiliatePageContactForm() {

  const [formData, setFormData] = useState({ location: '' });
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState('');

  const handleInput = useCallback((e) => {
    const { value } = e.target;
    const field = e.target.id;
    setFormData({
      ...formData,
      [field]: value,
    });
  }, [formData]);

  const closeSuccessMessage = () => {
    setShowMessage(false);
  };

  const submitForm = useCallback(() => {
    callApi(SEND_AFFILIATE_CONTACT_FORM, 'post', {}, formData, {}, false, false, false).
      then((res) => {
        if (res.status === 204) {
          setShowMessage(true);
          setMessage('Thank you for your submission, we will contact you shortly.');
          setFormData({
            name: '',
            email: '',
            reason: '',
            location: '',
          });
        }
      }).
      catch((err) => {
        setShowMessage(true);
        setMessage('Name & Email are mandatory fields.');
      });
  }, [formData]);

  return (
    <div className="affiliate container white-bg form flex flex-col justify-evenly">
      <h2 className="title-large">CONTACT US</h2>
      <h3 className="gray">Please feel free to reach us if you have any questions.</h3>
      <form action="" className="form gray">
        <div className="contact-form inputs flex flex-col justify-between">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            placeholder="Your Name"
            required="required"
            type="text"
            value={formData.name}
            onChange={handleInput}
          />
        </div>
        <div className="contact-form inputs flex flex-col justify-between">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            placeholder="email@domainname.com"
            required="required"
            type="text"
            value={formData.email}
            onChange={handleInput}
          />
        </div>
        <div className="contact-form inputs flex flex-col justify-between">
          <label htmlFor="reason">Message</label>
          <textarea
            className="text-box"
            cols={40}
            id="reason"
            maxLength="2048"
            rows={5}
            type="text"
            value={formData.reason}
            onChange={handleInput}
          />
        </div>
      </form>

      <button className="contact-form-submit" onClick={submitForm}>SUBMIT MESSAGE</button>

      <Modal
        closeOnOuterClick={true}
        containerStyle={{
          width: '100%',
          padding: '0',
          marginTop: '100px',
          background: 'transparent',
        }}
        show={showMessage}
      >
        <div className="audition-form-success-message">
          <button onClick={closeSuccessMessage}>X</button>
          <h4>{message}</h4>
        </div>
      </Modal>
    </div>
  );
}


export default AffiliatePageContactForm;
